/**
 * BetterAuth Client
 *
 * Client-side authentication for Polygraf with MUNI SSO support.
 */

import { resolveApiBaseUrl } from '@polygraf/shared'
import { createAuthClient } from 'better-auth/react'
import { genericOAuthClient } from 'better-auth/client/plugins'

// Native bridge → VITE_API_URL → window.location.origin. The native fallback
// matters because the WebView origin differs from the API server.
const API_URL = resolveApiBaseUrl(
	import.meta.env.VITE_API_URL,
	typeof window !== 'undefined' ? window.location.origin : '',
)

export const authClient = createAuthClient({
	baseURL: API_URL,
	plugins: [genericOAuthClient()],
})

export const {
	signIn,
	signUp,
	signOut,
	useSession,
	getSession,
	changePassword,
	requestPasswordReset,
	resetPassword,
} = authClient
